import React from "react";
import { formatNumberWithCommas } from "../../../../util/formatNumber";
import {
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Label,
  ComposedChart,
  ResponsiveContainer,
} from "recharts";
import CancelCountCustomTick from "./cancelCountCustomTick";
import CancelCountCustomTooltip from "./cancelCountCustomTooltip";

const CancelCountChart = ({ dataList, dateType }) => {
  // dataList 역순으로 정렬
  dataList = dataList.reverse();

  return (
    <div
      style={{
        width: "100%",
        height: "fit-content",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "53px 0px 40px 0px",
      }}
    >
      <ResponsiveContainer width={869} height={254}>
        <ComposedChart
          data={dataList}
          margin={{ top: 30, right: 30, left: 30, bottom: 20 }}
        >
          <CartesianGrid stroke="rgba(255, 255, 255, 0.12)" vertical={false} />
          <XAxis
            dataKey="date"
            axisLine={false}
            stroke="rgba(255, 255, 255, 0.12)"
            tickSize={0} // 눈금 제거
            tick={({ x, y, payload, index }) => (
              <CancelCountCustomTick
                x={x}
                y={y}
                payload={payload}
                index={index}
                data={dataList}
                dateType={dateType}
              />
            )}
            tickMargin={28}
            interval={0}
          />
          <YAxis
            yAxisId="left"
            orientation="left"
            axisLine={false}
            stroke="rgba(255, 255, 255, 0.12)"
            width={76}
            tickFormatter={(value) => formatNumberWithCommas(value)}
            tickSize={0}
            tickMargin={20} // 숫자와 축 사이의 간격 조정
            tick={{
              fontFamily: "Pretendard",
              fontWeight: 500,
              fontSize: 13,
              lineHeight: "18.75px",
              fill: "#aaa",
              textAnchor: "end",
            }}
          >
            <Label
              value="(명)"
              position="insideBottom" // "insideBottomRight", "insideBottom", "insideBottomLeft", "insideTopRight", "insideTop", "insideTopLeft"
              offset={-26} // Y축에 가까이 붙게 하려면 offset 값을 음수로 설정
              dx={10}
              style={{
                fontFamily: "Pretendard",
                fontWeight: 500,
                fontSize: 13,
                lineHeight: "18.75px",
                fill: "rgba(181, 181, 181, 0.5)",
              }}
            />
          </YAxis>
          <Tooltip
            cursor={false}
            content={<CancelCountCustomTooltip dateType={dateType} />}
          />
          <Bar
            yAxisId="left"
            dataKey="cancelcount"
            fill="#cf6679"
            radius={[5, 5, 0, 0]}
            barSize={14}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CancelCountChart;
